import React, {useState} from "react";
import {useDispatch} from 'react-redux';
import { setSimulateurObject } from "../../../actions/simulateur.action.js";
import {styles} from "../../../stylesheets/simulateurs.css";
import "../../../stylesheets/simulateursBis.css";
import TextSimulateurTitle from "../../../components/texts/text.simulateurTitle";
import TextfieldNumber from "../../../components/textfields/textfield.number";
import TextfieldRemarques from "../../../components/textfields/textfiel.remarques";
import ButtonTextCustom from "../../../components/buttons/button.text.custom.js";
import { ToolTipPerso } from "../../../components/selects/tooltip_perso.js";
import ButtonYesno from "../../../components/buttons/button.yesno.js";

//Espérance de vie
//Id 118

function Simulateur_118(props) {
    const dispatch = useDispatch();

    const [usufruitier_successif_esp, setUsufruitierSuccessif] = useState(0);
    const [genre, setGenre] = useState(0);
    const [age_usufruitier, setAgeUsufruitier] = useState(null);
    const [genre_actuel, setGenreActuel] = useState(0);
    const [genre_successif, setGenreSuccessif] = useState(0);
    const [age_usufruitier_actuel, setAgeUsufruitierActuel] = useState(null);
    const [age_usufruitier_successif, setAgeUsufruitierSuccessif] = useState(null);

    const handleChange = async (setter, value) => {
        setter(value)
        setInRedux(setter, value)
    }

    const handleChangeRemarque = async (value) => {

        localStorage.setItem("remarque", value)
    }
    function setInRedux(setter, value) {
        
        let object ={
            "simulateurid": props.simulateur.id,
            "inputs": {
                usufruitier_successif_esp: parseInt(usufruitier_successif_esp),
                genre: parseInt(genre),
                age_usufruitier: parseInt(age_usufruitier),
                genre_actuel: parseInt(genre_actuel),
                genre_successif: parseInt(genre_successif),
                age_usufruitier_actuel: parseInt(age_usufruitier_actuel),
                age_usufruitier_successif: parseInt(age_usufruitier_successif),
            }
        };
        
        if (setter === setUsufruitierSuccessif) {
            if(value === 1) {
                setAgeUsufruitier(null);
                setGenre(0);
                Object.assign(object["inputs"], {
                usufruitier_successif_esp: parseInt(value),
                genre: parseInt(0),
                age_usufruitier: parseInt(null),
            });
            } else {
                setGenreActuel(0);
                setGenreSuccessif(0);
                setAgeUsufruitierActuel(null);
                setAgeUsufruitierSuccessif(null);
                Object.assign(object["inputs"], {
                usufruitier_successif_esp: parseInt(value),
                genre_actuel: parseInt(0),
                genre_successif: parseInt(0),
                age_usufruitier_actuel: parseInt(null),
                age_usufruitier_successif: parseInt(null),
            });
            }
        }
        if (setter === setGenre) { Object.assign(object["inputs"], {genre: parseInt(value)}); }
        if (setter === setAgeUsufruitier) { Object.assign(object["inputs"], {age_usufruitier: parseInt(value)}); }
        if (setter === setAgeUsufruitierActuel) { Object.assign(object["inputs"], {age_usufruitier_actuel: parseInt(value)}); }
        if (setter === setGenreActuel) { Object.assign(object["inputs"], {genre_actuel: parseInt(value)}); }
        if (setter === setAgeUsufruitierSuccessif) { Object.assign(object["inputs"], { age_usufruitier_successif: parseInt(value)}); }
        if (setter === setGenreSuccessif) { Object.assign(object["inputs"], { genre_successif: parseInt(value)}); }
        if (props.isParent) {
            dispatch(setSimulateurObject(object));
        } else {
            let key;
            if (setter === setUsufruitierSuccessif) {
                if(value === 1) {
                    
                    props.handleChange(props.setDataEsperanceVie, null, "age_usufruitier")
                    props.handleChange(props.setDataEsperanceVie, 0, "genre")
                    props.handleChange(props.setDataEsperanceVie, parseInt(value), "usufruitier_successif_esp")
                    return
                } else {
                    props.handleChange(props.setDataEsperanceVie, 0, "genre_actuel")
                    props.handleChange(props.setDataEsperanceVie, 0, "genre_successif")
                    props.handleChange(props.setDataEsperanceVie, null, "age_usufruitier_actuel")
                    props.handleChange(props.setDataEsperanceVie, null, "age_usufruitier_successif")
                    props.handleChange(props.setDataEsperanceVie, parseInt(value), "usufruitier_successif_esp")
                    return
                }
            }
            if (setter === setGenre) { key = "genre"}
            if (setter === setAgeUsufruitier) { key = "age_usufruitier"}
            if (setter === setAgeUsufruitierActuel) { key = "age_usufruitier_actuel"}
            if (setter === setGenreActuel) { key = "genre_actuel"}
            if (setter === setAgeUsufruitierSuccessif) { key = "age_usufruitier_successif"}
            if (setter === setGenreSuccessif) { key = "genre_successif"}
            props.handleChange(props.setDataEsperanceVie, parseInt(value), key)
            // process child simu
        }
    }

    return (
        <div style={styles.container}>
            <div className={props.callSinceSimu ? "cardDMTG" : "cardSimulateur"}>
                {props.callSinceSimu ? (
                    <></>
                ):(
                    <>
                        <TextSimulateurTitle title={props.simulateur.name} currentSimuId={props.simulateur.id}/>

                        <TextfieldRemarques handleChange={handleChangeRemarque}/>

                        <p style={styles.cardSubTitle}>
                            Sources : Tables de mortalité par génération en France de l'<a target="_blank" rel="noopener noreferrer" href="https://www.insee.fr/fr/statistiques/6543678?sommaire=6543680">Insee</a> parues le 10/11/2022 
                        </p>
                    </>
                )
                }
                <div className="cardRow">
                    <div style={styles.cardElemVerticalyCenter}>
                        Y a-t-il un usufruitier actuel et un usufruitier successif ?
                        <ToolTipPerso
                            title={
                                "Ce champ est pertinent seulement si l’espérance de vie de l’usufruitier successif est supérieur à celui de l’usufruitier actuel. \n \n" +
                                "Si l’usufruit vendu est commun, il faut retenir la moitié de la valeur et procéder à deux simulations, même si le prix de vente de l’usufruit vendu est commun.\n" +
                                "Si l’usufruit vendu est indivis, il faut appliquer la quote-part indivise de chaque usufruitier à la valeur de la pleine propriété puis procéder à deux simulations.\n" +
                                "S’il est commun ou indivis, il faut appliquer la même proportion aux montants des charges pour calculer correctement le taux de rendement."
                            }
                        />
                    </div>
                    <div>
                        <ButtonYesno handleChange={handleChange} setter={setUsufruitierSuccessif} defaultValue={0} />
                    </div>
                </div>

                {usufruitier_successif_esp ? (
                    <>
                        <div style={styles.cardFlexSuccession}>
                            <div style={styles.cardFlexContainer}>
                                <div style={styles.cardTitleDonataire}>Concernant l'usufruitier actuel :</div>
                                <div className="cardRow">
                                    <div style={styles.cardElemVerticalyCenter}>
                                        Est-ce :
                                    </div>
                                    <div>
                                        
                                        <ButtonTextCustom handleChange={handleChange} setter={setGenreActuel} fieldUndefined={false} defaultValue={0} val1="Un homme" val2="Une femme"/>
                                    </div>
                                </div>
                                <div className="cardRow">
                                    <div style={styles.cardElemVerticalyCenter}>
                                        Indiquer l'âge de l'usufruitier actuel :
                                    </div>
                                    <TextfieldNumber
                                        handleChange={handleChange}
                                        type={"number"}
                                        placeholder={"Indiquer l'âge"}
                                        setter={setAgeUsufruitierActuel}
                                        value={age_usufruitier_actuel}
                                    />
                                </div>
                            </div>
                            <div style={styles.cardFlexContainer}>
                                <div style={styles.cardTitleDonataire}>Concernant l'usufruitier successif :</div>
                                <div className="cardRow">
                                    <div style={styles.cardElemVerticalyCenter}>
                                            Est-ce :
                                        </div>
                                        <div>
                                            <ButtonTextCustom handleChange={handleChange} setter={setGenreSuccessif} fieldUndefined={false} defaultValue={0} val1="Un homme" val2="Une femme"/>
                                    </div>
                                </div>
                                <div className="cardRow">
                                    <div style={styles.cardElemVerticalyCenter}>
                                        Indiquer l'âge de l'usufruitier successif :
                                    </div>
                                    <TextfieldNumber
                                        handleChange={handleChange}
                                        type={"number"}
                                        placeholder={"Indiquer l'âge"}
                                        setter={setAgeUsufruitierSuccessif}
                                        value={age_usufruitier_successif}
                                    />
                                </div>
                            </div>
                        </div>
                    </>
                ) : (
                    <>
                        <div className="cardRow">
                                <div style={styles.cardElemVerticalyCenter}>
                                    Est-ce :
                                </div>
                                <div>
                                    <ButtonTextCustom handleChange={handleChange} setter={setGenre} fieldUndefined={false} defaultValue={0} val1="Un homme" val2="Une femme"/>
                                </div>
                            </div>
                        <div className="cardRow">
                            <div style={styles.cardElemVerticalyCenter}>
                                Indiquer l'âge de l'usufruitier actuel :
                            </div>
                            <TextfieldNumber
                                handleChange={handleChange}
                                type={"number"}
                                placeholder={"Indiquer l'âge"}
                                setter={setAgeUsufruitier}
                                value={age_usufruitier}
                            />
                        </div>
                    </>
                )}
            </div>
        </div>
    )
}

export default Simulateur_118;